import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const cancelSlice = createSlice({
  name: 'cancel',
  initialState,
  reducers: {
    cancelRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    cancelSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    cancelFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    cancelReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const cancelAction = cancelSlice.actions;
export default cancelSlice;